import { Button, Icon, SuiTable } from '@britishcouncil/react-admin';
import { NoPlannedSessionsPlaceholder } from './NoPlannedSessionsPlaceholder';
import { useSpeakingSessions } from './useSpeakingSessions';
import { columns } from './columns';
import { BreadcrumbsActionsPortal, DebouncedFullScreenLoader } from 'components';
import { useAllowedActions } from 'hooks';
import styled from '@emotion/styled';
import { Link, generatePath } from 'react-router';
import { ROUTING_PATHS } from 'const';

export const SpeakingSessions = () => {
  const { createSpeakingSession } = ROUTING_PATHS;
  const { speakingSessions, isFetching, isLoading, onTableStateChange, tableState } =
    useSpeakingSessions();
  const { canCreateSpeakingSession } = useAllowedActions();

  if (!speakingSessions) return <DebouncedFullScreenLoader isFetching={isLoading} />;

  return speakingSessions.results?.length ? (
    <>
      <BreadcrumbsActionsPortal>
        {canCreateSpeakingSession && (
          <S.CreateLink
            to={generatePath(createSpeakingSession.absolutePath)}
            data-testid="create-speaking-session"
          >
            <Button compact primary>
              <Icon name="plus square" />
              Create
            </Button>
          </S.CreateLink>
        )}
      </BreadcrumbsActionsPortal>
      <S.TableWrapper>
        <SuiTable
          columns={columns}
          data={speakingSessions.results}
          state={tableState}
          totalCount={speakingSessions.totalCount}
          onStateChange={onTableStateChange}
          loading={isFetching}
          disableFilters
          pageSizes={[10, 25, 50, 100]}
          attached
          tableProps={{ 'data-testid': 'speaking-sessions-list' }}
        />
      </S.TableWrapper>
    </>
  ) : (
    <NoPlannedSessionsPlaceholder />
  );
};

const S = {
  TableWrapper: styled.div`
    & > .ui.segment.attached {
      width: 100%;
    }
  `,
  CreateLink: styled(Link)`
    margin-right: 1rem;
  `,
};